import type {Translator} from '@yandex-delivery/core/i18n'
import React from 'react'

import {Button} from '../button'
import {Grid} from '../grid'
import {Typography} from '../typography'
import imageSrc from './assets/image.svg'
import {classes} from './ErrorNotify.classes'

type Props = {
  componentStack?: string
  error?: Error
  reqId?: string
  t: Translator
}

const ErrorNotify: React.FC<Pick<Props, 't' | 'reqId'>> = ({t, reqId}) => (
  <Grid alignItems="center" className={classes.root} direction="column" justify="center" spacing={2} container>
    <Grid component={Typography} group="normal" thickness="bold" variant="title1" item>
      {t('error-screen.title', 'У нас что-то сломалось')}
    </Grid>
    <Grid className={classes.description} component={Typography} group="loose" variant="body2" item>
      {t('error-screen.caption', 'Мы знаем и уже чиним.\nСкоро всё заработает.')}
    </Grid>
    <Grid component={Button} onPress={() => window.location.reload()} variant="action" item>
      {t('error-screen.btn', 'Обновить страницу')}
    </Grid>
    <Grid className={classes.image} item>
      <img alt="error" src={imageSrc} />
    </Grid>
    {!reqId ? null : (
      <Grid className={classes.reqId} item>
        {reqId}
      </Grid>
    )}
  </Grid>
)

export const createErrorNotify =
  <K extends keyof Props>(partProps: Pick<Props, K>) =>
  (restProps: Omit<Props, K>) =>
    (
      // @ts-expect-error Pick<Props, K> & Omit<Props, K> должно быть равно Props, но почему-то не тайпчекается
      <ErrorNotify {...partProps} {...restProps} />
    )

export default ErrorNotify
